import React from 'react';
import { Box, Typography } from '@mui/material';
import { FilterList } from '@mui/icons-material';

export const EmptyState: React.FC<{ isFiltered: boolean }> = ({
  isFiltered,
}) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        py: 8,
        textAlign: 'center',
      }}
    >
      {isFiltered ? (
        <>
          <FilterList sx={{ color: 'text.secondary', fontSize: 48, mb: 2 }} />
          <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
            No workflows match your current filters
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Try adjusting your search or filter criteria to see more results.
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
            {"You're all set! No workflows need your attention right now."}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {
              'Take a well-deserved break or check back later for new assignments.'
            }
          </Typography>
        </>
      )}
    </Box>
  );
};
